import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingRoutingModule } from './setting-routing.module';
import { AutoHealComponent } from './auto-heal/auto-heal.component';
import { AwsSettingComponent } from './aws-setting/aws-setting.component';
import { PartyIntegrationComponent } from './party-integration/party-integration.component';
import { ProjectSettingComponent } from './project-setting/project-setting.component';
import { SharedModule } from '../shared/shared.module';
import { AngularMaterialModule } from '../angular-material.module';
import { LayoutModule } from '../layout/layout.module';
import { SearchSettingPipe } from '../search-setting.pipe';


@NgModule({
  declarations: [ProjectSettingComponent, AwsSettingComponent, AutoHealComponent, PartyIntegrationComponent, SearchSettingPipe],
  imports: [
    CommonModule,
    LayoutModule,
    SettingRoutingModule,
    SharedModule,
    AngularMaterialModule
  ]
})
export class SettingModule { }
